import React, { Component } from "react";
import { connect } from "react-redux";
import CartOptions from "./CartOptions";
import {
  edit_quantity,
  remove_from_cart,
  setProduct,
} from "../../store/actions";
import {
  AddCircleOutline,
  Info,
  RemoveCircleOutline,
} from "@material-ui/icons";

import moment from "moment";
import { preciseNumber } from "../../store/reducers/cart";
import Grid from "@material-ui/core/Grid";
import Popover from "@material-ui/core/Popover";
import Divider from "@material-ui/core/Divider";
import { getMaximumProductInventoryFromModifiers } from "../Menu/Helpers";
import { GTM } from "../../App";
import ReactGA from "react-ga4";
import { withRouter } from "react-router-dom";
import dairyFreeIcon from "../ActionButton/assests/no-milk.png";
import glutenFreeIcon from "../ActionButton/assests/gluten-free.png";
import sugarFreeIcon from "../ActionButton/assests/sugar-free.png";
import nutFreeIcon from "../ActionButton/assests/peanut-free.png";
import organicIcon from "../ActionButton/assests/bio_480.png";
import vegetarianIcon from "../ActionButton/assests/leaf.png";
import veganIcon from "../ActionButton/assests/vegan.png";
import { getProductInventory } from "../../store/reducers/store";
import glutenIcon from "../ActionButton/assests/gluten.png";
import nutsSesameIcon from "../ActionButton/assests/nuts_sesame.png";
import dairyIcon from "../ActionButton/assests/dairy.png";
import eggIcon from "../ActionButton/assests/egg.png";
import seafoodShellfishIcon from "../ActionButton/assests/seafood_shellfish.png";
import chilliIcon from "../ActionButton/assests/chilli.png";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

export class CartItem extends Component {
  removeFromCartAnalytics = (product) => {
    const { settings } = this.props;

    if (settings.enable_google_analytics && settings.google_analytics) {
      ReactGA.event({
        category: "Removed From Cart",
        action: `User Removed ${product.name} From Cart`,
        label: "Removed From Cart",
      });

      ReactGA.gtag("event", "remove_from_cart", {
        value: product.price * product.quantity,
        currency: settings.currency_iso,
        items: [
          {
            item_id: product.id,
            item_name: product.name || "",
            price: product.price,
            quantity: product.quantity,
          },
        ],
      });
    }
    if (GTM) {
      GTM.track("remove_from_cart", {
        ecommerce: {
          items: [
            {
              item_id: product.id,
              item_name: product.name,
              currency: settings.currency_iso,
              price: product.price,
              quantity: product.quantity,
            },
          ],
        },
      });
    }
  };
  ar_days = {
    Sun: "اﻷحد",
    Mon: "اﻷثنين",
    Tue: "الثلاثاء",
    Wed: "اﻷربعاء",
    Thu: "الخميس",
    Fri: "الجمعة",
    Sat: "السبت",
  };
  ar_months = {
    Jan: "يناير ",
    Feb: "فبراير",
    Mar: "مارس",
    Apr: "أبريل",
    May: "مايو",
    Jun: "يونيو",
    Jul: "يوليو",
    Aug: "أغسطس",
    Sep: "سبتمبر",
    Oct: "أكتوبر",
    Nov: "نوفمبر",
    Dec: "ديسمبر",
  };
  state = {
    anchorEl: null,
  };
  getAddedQuantity = (store_product) => {
    let addedQuantity = 0;

    if (store_product.max_addable_quantity) {
      this.props.cart.forEach((product, index) => {
        if (product.id === store_product.id && this.props.index !== index)
          addedQuantity += product.quantity;
      });
    }
    return addedQuantity;
  };
  remove_from_cart = async (product_index, prouct, PromoItem = false) => {
    await this.props.remove_from_cart(product_index, prouct, PromoItem);

    this.removeFromCartAnalytics(prouct);
  };
  checkMinMaxOrPromo = (
    store_product,
    addedQuantity,
    newQuantity,
    PromoItem
  ) => {
    if (
      PromoItem ||
      ((store_product.max_addable_quantity === null ||
        newQuantity + addedQuantity <= store_product.max_addable_quantity) &&
        newQuantity >= store_product.min_addable_quantity)
    ) {
      return true;
    }
    return false;
  };
  changeQuantity = (item, quantity, store_product, PromoItem = false) => {
    const { usedComponents } = this.props;
    const addedQuantity = this.getAddedQuantity(store_product);
    const newQuantity = preciseNumber(quantity + this.props.item.quantity);

    if (PromoItem) {
      let discount_item;
      if (item?.discountType === "category_free") {
        discount_item = this.props.promotions.category_free.find(
          (p) => p.id === item.discount && p.promo === item.promo
        );
      } else {
        discount_item = this.props.promotions.products.find(
          (p) =>
            p.id === item.discount &&
            ((p.has_variants && p.product === item.parent) ||
              (!p.has_variants && p.product === item.id))
        );
      }

      if (discount_item) {
        if (quantity > discount_item.quantity) return;
      } else {
        return;
      }
    }
    if (
      newQuantity > 0 &&
      this.checkMinMaxOrPromo(
        store_product,
        addedQuantity,
        newQuantity,
        PromoItem
      ) &&
      ((item.is_preordered && quantity <= store_product.preorder_inventory) ||
        (!item.is_preordered &&
          ((["stocked", "composite"].includes(store_product.type_of_product) &&
            quantity <= getProductInventory(store_product, usedComponents)) ||
            store_product.type_of_product === "produced" ||
            (store_product.type_of_product === "bookable" &&
              quantity <=
                store_product.booking_slots.find(
                  (slot) => slot.id === this.props.item.booking_slot
                ).inventory)))) &&
      newQuantity <=
        getMaximumProductInventoryFromModifiers(
          this.props.item.options,
          this.props.item.quantity,
          usedComponents,
          null,
          null,
          store_product
        )
    )
      this.props.edit_quantity(
        this.props.index,
        item,
        newQuantity,
        quantity,
        PromoItem,
        item.is_preordered
      );
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handleOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  getBooking = (booking) => {
    let [year, month, day] = booking.booking_date.split("-");

    let date = new Date(year, month - 1, day);

    date = date.toString().split(" ");
    let day_numb = parseInt(date[2], 10);
    day = this.props.language === "english" ? date[0] : this.ar_days[date[0]];

    month =
      this.props.language === "english" ? date[1] : this.ar_months[date[1]];

    let formattedDate;

    if (!booking.all_day) {
      formattedDate = `${day} ${day_numb} ${month} - ${booking.start.slice(
        booking.start[0] === "0" ? 1 : 0,
        5
      )}`;

      if (this.props.settings.show_booking_end_slot) {
        formattedDate += ` ${
          this.props.language === "arabic" ? "حتى" : "to"
        } ${booking.end.slice(booking.end[0] === "0" ? 1 : 0, 5)}`;
      }
    } else {
      formattedDate = `${day} ${day_numb} ${month} - ${
        this.props.language === "arabic" ? "البوم باكمله" : "Whole Day"
      }`;
    }

    return <span>{formattedDate}</span>;
  };

  translateSlotText = (text) => {
    const { language } = this.props;
    if (language == "english") return text;

    let temp = text.replace(/PM/g, "م");
    temp = temp.replace(/AM/g, "ص");
    return temp;
  };

  translateDate = (date) => {
    const { language } = this.props;
    if (language == "english") return date;

    const ar_months = {
      January: "يناير ",
      February: "فبراير",
      March: "مارس",
      April: "أبريل",
      May: "مايو",
      June: "يونيو",
      July: "يوليو",
      August: "أغسطس",
      September: "سبتمبر",
      October: "أكتوبر",
      November: "نوفمبر",
      December: "ديسمبر",
    };
    let temp = date;
    Object.keys(ar_months).forEach((month) => {
      temp = temp.replace(month, ar_months[month]);
    });
    return temp;
  };

  renderResourceSlot = (slotStr) => {
    let [date, start, end] = slotStr.split(" ");

    date = moment(date, "YYYY-MM-DD").format("LL");
    start = moment(start, "HH:mm:ss").format("h:mm A");
    end = moment(end, "HH:mm:ss").format("h:mm A");

    return (
      <>
        <p className="mb-0">{this.translateDate(date)}</p>
        <p className="mb-0">{this.translateSlotText(`${start} - ${end}`)}</p>
      </>
    );
  };
  renderPopOverText = () => {
    const { item, language, settings } = this.props;
    const custom_texts = settings.custom_texts;
    const extraFields = Object.entries(item.extraFields);

    return (
      <div>
        {item.special_request && (
          <p>{`${
            (language === "arabic" &&
              custom_texts.special_request_product_ar) ||
            custom_texts.special_request_product
          }: 
            ${item.special_request}
          `}</p>
        )}
        {extraFields.map(([key, value]) => (
          <p key={key}>
            {`${(language === "arabic" && value.ar_name) || value.name}: ${
              value.value
            }`}
          </p>
        ))}
      </div>
    );
  };

  render() {
    let booking = null;
    let options = [];
    const { item, store, settings } = this.props;
    let store_product = this.props.store.categories.find(
      (category) => category.id === item.category_id
    );

    if (item.parent) {
      store_product = store_product.products
        .find(
          (parent) => parent.id === item.parent && parent.has_variants === true
        )
        .children.find((product) => product.id === item.id);
    } else {
      store_product = store_product.products.find(
        (product) => product.id === item.id
      );
    }
    if (!store_product) return <></>;

    if (item.booking_slot) {
      booking = store_product.booking_slots.find(
        (booking) => booking.id === item.booking_slot
      );
      if (booking) {
        booking = this.getBooking(booking);
      } else return <></>;
    }
    let language = this.props.language;

    const themeColor = this.props.themeColor;
    const open = Boolean(this.state.anchorEl);
    const id = open ? "simple-popover" : undefined;
    const hasStrikedPrice =
      store_product.striked_price &&
      store_product.striked_price >
        item.quantity * item.total_price + item.quantityExcludedOptionsTotal;
    const isDiscounted =
      (item.total_price * item.quantity + item.quantityExcludedOptionsTotal >
        this.props.priceAfterDiscount ||
        hasStrikedPrice) &&
      !item.promo;
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <>
        <div
          style={{
            padding: "5px 10px",
            backgroundColor: "white",
            margin: "5px 0px",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "50px auto 90px",
              gridTemplateRows: "60px auto 30px",
              alignItems: "center",
              direction: language === "arabic" ? "rtl" : "ltr",
            }}
          >
            <div>
              {!this.props.PromoItem && (
                <div className="mb-2">
                  <span
                    onClick={() => {
                      this.props.setProduct(null);
                      this.props.history.push({
                        pathname: `/product/${store_product.category}/${
                          store_product.parent ? `${store_product.parent}/` : ""
                        }${store_product.slug}`,
                        state: {
                          editMode: true,
                          editedProduct: { ...item, index: this.props.index },
                        },
                      });
                    }}
                    style={{
                      cursor: "pointer",
                      fontSize: "0.9rem",
                      color: themeColor,
                      position: "relative",
                      right: language !== "arabic" && 10,
                      left: language === "arabic" && 10,
                    }}
                    className="bold"
                  >
                    {language === "arabic" ? "تعديل" : "edit"}
                  </span>
                </div>
              )}
              <img
                alt={store_product.name}
                style={{
                  borderRadius: 4,
                  width: 50,
                  height: 50,
                }}
                src={
                  store_product &&
                  (store_product.photo_thumb || store_product.photo)
                }
              />
            </div>

            <div
              style={{
                textAlign: language === "arabic" ? "right" : "left",
                [`padding${language === "arabic" ? "Right" : "Left"}`]: 14,
              }}
            >
              <span className="bold">
                {language === "english"
                  ? store_product.name
                  : store_product.ar_name || store_product.name}
                {booking ? (
                  <small>
                    <br />
                    {booking}
                  </small>
                ) : null}
              </span>
              {(item.special_request || !isEmpty(item.extraFields)) && (
                <span style={{ margin: "0px 5px" }}>
                  <Info style={{ width: "20px" }} onClick={this.handleOpen} />
                  <Popover
                    PaperProps={{ style: { padding: 10 } }}
                    id={id}
                    open={open}
                    anchorEl={this.state.anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                  >
                    <div
                      className={`${
                        language === "english"
                          ? "pr-2 pl-1 text-left"
                          : "pr-2 pl-3 text-right"
                      }`}
                      style={{
                        fontWeight: "bold",
                        fontFamily:
                          language == "english" ? "Quicksand" : "Cairo",
                        direction: language == "english" ? "ltr" : "rtl",
                      }}
                    >
                      {this.renderPopOverText()}
                    </div>
                  </Popover>
                </span>
              )}
            </div>

            <div
              style={{
                direction: language === "english" ? "rtl" : "ltr",
                textAlign: language === "english" ? "right" : "left",
                color: themeColor,
                fontSize: "1rem",
                width: "100%",
                whiteSpace: "nowrap",
              }}
              className="bold"
            >
              {isDiscounted ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span
                    className={`bold ${
                      currencyIcon
                    }`}
                    style={{
                      textDecoration: "line-through",
                      display: "inline",
                      fontSize: 11,
                    }}
                  >
                    {hasStrikedPrice ? (
                      <>
                        {language === "english"
                          ? store.settings.currency_english
                          : store.settings.currency_local}{" "}
                        {(store_product.striked_price * item.quantity).toFixed(
                          store.settings.currency_decimals
                        )}
                      </>
                    ) : (
                      <>
                        {language === "english"
                          ? store.settings.currency_english
                          : store.settings.currency_local}{" "}
                        {(
                          item.quantity * item.total_price +
                          item.quantityExcludedOptionsTotal
                        ).toFixed(store.settings.currency_decimals)}
                      </>
                    )}
                  </span>
                  <span
                    className={`bold ${
                      currencyIcon
                    }`}
                  >
                    {language === "english"
                      ? store.settings.currency_english
                      : store.settings.currency_local}{" "}
                    {this.props.priceAfterDiscount.toFixed(
                      store.settings.currency_decimals
                    )}
                  </span>
                </div>
              ) : (
                <span
                  className={`bold ${
                    currencyIcon
                  }`}
                >
                  {language === "english"
                    ? store.settings.currency_english
                    : store.settings.currency_local}{" "}
                  {(
                    item.quantity * item.total_price +
                    item.quantityExcludedOptionsTotal
                  ).toFixed(store.settings.currency_decimals)}
                </span>
              )}
            </div>

            <div className="empty"></div>

            <div>
              {store_product.type_of_product == "service" &&
              item.resource &&
              item.resourceSlot ? (
                <div
                  style={{
                    textAlign: language === "arabic" ? "right" : "left",
                  }}
                  className="mx-2 px-2 mb-2"
                >
                  <p
                    className="m-0"
                    style={{ direction: language == "english" ? "ltr" : "rtl" }}
                  >
                    {language == "english" ? "With" : "مع"}:{" "}
                    {language == "english"
                      ? item.resource.name
                      : item.resource.ar_name || item.resource.name}
                  </p>
                  <div
                    className="m-0"
                    style={{ direction: language == "english" ? "ltr" : "rtl" }}
                  >
                    {this.renderResourceSlot(item.resourceSlot)}
                  </div>
                </div>
              ) : null}

              <CartOptions
                product={item}
                cart={false}
                originalProduct={store_product}
              />

              {settings.show_nutrition_facts && (
                <div
                  className="ml-3"
                  style={{
                    textAlign:
                      this.props.language === "arabic" ? "right" : "left",
                  }}
                >
                  {this.props.dietaryRestrictions?.isDairyFree && (
                    <img
                      src={dairyFreeIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {this.props.dietaryRestrictions?.isGlutenFree && (
                    <img
                      src={glutenFreeIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {this.props.dietaryRestrictions?.isSugarFree && (
                    <img
                      src={sugarFreeIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {this.props.dietaryRestrictions?.isNutFree && (
                    <img
                      src={nutFreeIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {this.props.dietaryRestrictions?.isVegan && (
                    <img
                      src={veganIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {this.props.dietaryRestrictions?.isVegetarian && (
                    <img
                      src={vegetarianIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {this.props.dietaryRestrictions?.isOrganic && (
                    <img
                      src={organicIcon}
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                  {this.props.dietaryRestrictions?.containsGluten && (
                    <img
                      src={glutenIcon}
                      alt="Gluten"
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}

                  {this.props.dietaryRestrictions?.containsNutsSesame && (
                    <img
                      src={nutsSesameIcon}
                      alt="Nuts/Sesame"
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}

                  {this.props.dietaryRestrictions?.containsDairy && (
                    <img
                      src={dairyIcon}
                      alt="Dairy"
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}

                  {this.props.dietaryRestrictions?.containsEgg && (
                    <img
                      src={eggIcon}
                      alt="Egg"
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}

                  {this.props.dietaryRestrictions?.containsSeafoodShellfish && (
                    <img
                      src={seafoodShellfishIcon}
                      alt="Seafood/Shellfish"
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}

                  {this.props.dietaryRestrictions?.containsChilli && (
                    <img
                      src={chilliIcon}
                      alt="Chilli"
                      style={{ marginRight: 5, height: 17, width: 17 }}
                    />
                  )}
                </div>
              )}
            </div>

            <div className="empty"></div>

            <div>
              <span
                onClick={() =>
                  this.remove_from_cart(
                    this.props.index,
                    item,
                    this.props.PromoItem
                  )
                }
                style={{
                  color: "#ff4242",
                  cursor: "pointer",
                  fontSize: "0.9rem",
                  position: "relative",

                  left: language === "arabic" && 10,
                }}
                className="bold"
              >
                {language === "arabic" ? "إزالة" : "remove"}
              </span>
            </div>

            <div className="empty"></div>

            {store_product.type_of_product !== "service" &&
              (!store_product.hide_quantity_box || item.quantity > 1) && (
                <div>
                  <Grid
                    direction={language === "arabic" && "row-reverse"}
                    className="mx-auto mt-1"
                    alignItems="center"
                    justify="space-around"
                    container
                    style={{
                      width: 95,
                      backgroundColor: "white",
                      height: 30,
                    }}
                  >
                    {!store_product.hide_quantity_box && (
                      <Grid
                        item
                        onClick={() =>
                          this.changeQuantity(
                            item,
                            parseFloat(-store_product.increments),
                            store_product,
                            this.props.PromoItem
                          )
                        }
                        className="option-quantity-button"
                      >
                        <RemoveCircleOutline
                          style={{
                            color:
                              parseFloat(
                                -store_product.increments + item.quantity
                              ) <= 0
                                ? "#d8d8d8"
                                : themeColor,
                          }}
                        />
                      </Grid>
                    )}
                    <Grid item>
                      <div
                        className="text-center"
                        style={{
                          color: themeColor,
                          border: "0.5px solid #DEDEDE",
                          borderRadius: 5,
                          width: 35,
                          padding: 1,
                        }}
                      >
                        {item.quantity}
                      </div>
                    </Grid>
                    {!store_product.hide_quantity_box && (
                      <Grid
                        item
                        onClick={() =>
                          this.changeQuantity(
                            item,
                            parseFloat(store_product.increments),
                            store_product,
                            this.props.PromoItem
                          )
                        }
                        className="option-quantity-button"
                      >
                        <AddCircleOutline style={{ color: themeColor }} />
                      </Grid>
                    )}
                  </Grid>
                </div>
              )}
          </div>
        </div>
        {!this.props.hideDivider && (
          <Divider variant="middle" style={{ margin: "12px 30px" }} />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    store: state.store.store,
    settings: state.store.store.settings,
    cart: state.cart.cart,
    themeColor: state.store.store.settings.dark,
    promotions: state.cart.discounts,
    usedComponents: state.store.used_components,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    edit_quantity: (
      item,
      product_index,
      product,
      quantity,
      change,
      PromoItem,
      isPreordering
    ) =>
      dispatch(
        edit_quantity(
          item,
          product_index,
          product,
          quantity,
          change,
          PromoItem,
          isPreordering
        )
      ),
    remove_from_cart: (item_index, item, PromoItem) =>
      dispatch(remove_from_cart(item_index, item, PromoItem)),
    setProduct: (product) => dispatch(setProduct(product)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CartItem));
